import { pick, flow, map, isNumber } from "lodash";
import drushim_lodash from "lodash";
import { getFormattedValue } from '@/lib/urlUtils'

export function getCodes(jobsArray) {
    let tempArr = [];
    jobsArray.forEach((job) => {
        tempArr.push(job.Code);
    });
    return tempArr;
}

export function prepareCodesForSend(codesArray) {
    let codesStr = "jobCode=";
    codesArray.forEach((code) => {
        codesStr = codesStr.concat(code.toString(), ",");
    });
    return codesStr.substring(0, codesStr.length - 1);
}

export function buildString(codesString, queryName) {
    try {
        codesString = getFormattedValue(decodeURIComponent(codesString))
    } catch (error) {
        console.log('jobsList buildString', error)
        codesString = getFormattedValue(codesString)
    }

    if (queryName === "search") {
        queryName = "searchTerm";
    }

    return queryName + "=" + codesString;
}

/**
 * @param {*} routeQueries
 * @returns {String} route query string
 */
export function checkForRouteQueries(routeQueries) {
    const pickNeeded = (obj) =>
        pick(obj, [
            "searchterm",
            "scope",
            "experience",
            "city",
            "geolexid",
            "range",
            "ssaen",
            "iscorona",
            "catdir",
            "area",
            "exact",
            "cv"
        ]);

    const build = (obj) => map(obj, buildString).join("&");
    var routeQueriesLowerCase = drushim_lodash.transform(routeQueries, function(result, val, key) {
        result[key.toLowerCase()] = val;
    });
    return flow(pickNeeded, build)(routeQueriesLowerCase);
}

export function sliceCatCode(cat) {
    return !isNumber(cat) ? cat.replace("cat", "") : cat;
}

export function prepareCatParam(catParam) {
    if (catParam.cat) {
        catParam.cat = sliceCatCode(catParam.cat);
    }
    return catParam;
}

export function checkForRouteParams(routeParams) {
    const pickNeeded = (obj) =>
        pick(obj, ["area", "subcat", "cat", "search", "ssaen", "isCorona"]);
    const mapcat = (obj) =>
        drushim_lodash.mapKeys(obj, (value, key) => (key === "cat" ? "catdir" : key));
    const build = (obj) => map(obj, buildString).join("&");

    return {
        searchStr: flow(prepareCatParam, pickNeeded, mapcat, build)(routeParams),
    };
}
